<footer class="footer" *ngIf="!(isAuthenticated$ | async)">
  <div class="footer-container">
    <!-- Footer per utenti non autenticati (landing) -->
    <div class="footer-landing">
      <div class="footer-content">
        <div class="footer-brand">
          <div class="footer-brand-row">
            <h3 class="footer-title">Referenze di COOPROGETTI</h3>
            <p class="footer-description">
              Repository di referenze
            </p>
          </div>
        </div>

        <!-- <div class="footer-links">
          <div class="footer-section">
            <h4>Prodotto</h4>
            <a (click)="scrollToSection('.features-section')">Funzionalità</a>
            <a href="#">Documentazione</a>
          </div>

          <div class="footer-section">
            <h4>Azienda</h4>
            <a href="#">Chi Siamo</a>
            <a href="#">Contatti</a>
          </div>

          <div class="footer-section">
            <h4>Supporto</h4>
            <a href="#">FAQ</a>
            <a href="#">Assistenza</a>
          </div>
        </div> -->
      </div>

      <div class="footer-bottom">
        <div class="footer-left">
          <p class="footer-copyright">
            © {{ currentYear }} COOPROGETTI Refhub. Tutti i diritti riservati.
          </p>
        </div>
        <div class="footer-legal">
          <a href="#">Privacy Policy</a>
          <a href="#">Termini di Servizio</a>
        </div>
      </div>
    </div>
  </div>
</footer>

